import styled, { css } from 'styled-components'
import PlaceHolder from 'Components/PlaceHolder'
import BlurCont from 'Layout/BlurCont'
import { GREY_BACKGROUND, FONT_BASE_COLOR, ERROR_COLOR, PRIMARY_DARK_COLOR } from '@CSSVars/colors'

export const _FloatingPanel = styled.div`
  width: 356px;
  height: fit-content;
  position: sticky;
  top: 90px;
`

export const _Listing = styled.div`
  padding: 24px;
  background-color: ${GREY_BACKGROUND};
  margin-bottom: 10px;
  border-radius: 10px;
  margin-top: 12px;
`

const titleMixin = css`
  padding: 0;
  font-family: var(--secondary-font);
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: ${FONT_BASE_COLOR};
  text-transform: ${({ isAskingPriceAvailable }) => (isAskingPriceAvailable ? 'capitalize' : 'none')};
  pointer-events: visible;
`

export const _Title = styled.h2`
  ${titleMixin};
`

export const _PlaceholderTitle = styled(PlaceHolder)`
  ${titleMixin};
`

export const _Price = styled(BlurCont)`
  ${titleMixin};
  font-size: 18px;
  margin-bottom: 6px;
`

export const _ClosedPrice = styled.h2`
  ${titleMixin};
  font-size: 18px;
  margin-bottom: 6px;
  color: ${ERROR_COLOR};
  div {
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
  }
  display: inline-flex;
  flex-direction: row;
  align-items: center;
`

export const _Anchor = styled.a`
  padding-top: 12px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  .is-current {
    background: red;
    color: green;
  }
`

export const _AnchorContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  .highlightedSection {
    color: ${PRIMARY_DARK_COLOR};
  }
`

export const _AgentContainer = styled.div`

`
